<template>
  <span class="text-sm text-miliorange uppercase">
    {{ discountMarkdown === 1
      ? trans.get('miliboo.common.sales')
      : discountMarkdown === 2
        ? trans.get('miliboo.common.second-discount')
        : trans.get('miliboo.common.third-discount') }}
  </span>
</template>

<script setup>
import { inject } from 'vue';

const trans = inject('translate');

defineProps({
  discountMarkdown: {
    type: Number,
    required: true,
  },
});
</script>
